import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCypressComponent } from './simple-icons-cypress.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCypressComponent ],
    exports:      [ SimpleIconsCypressComponent ],
    bootstrap:    []
})
export class SimpleIconsCypressModule {}
